import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";

const T = {
  categories: [
    "Dummy 1",
    "Dummy 2",

    "Dummy 3",
    "Dummy 4",
    "Dummy 5",
    "Dummy 6",
    "Dummy 7",
    "Dummy 8",
  ],
  footer: {
    getApp: "Få appen for klarhet hvor du enn er.",
    explore: "Utforsk",
    special: "Spesialiteter",
    more: "Mer",
    advisors: "Veiledere",
    blog: "Bloggen vår",
    applyCode: "Bruk kampanjekode",
    support: "Kundesupport",
    about: "Om oss",
    apply: "Veileder? Søk her",
    privacy: "Personvern",
    terms: "Vilkår",
  },
};

export function Footer({ baseUrl }) {
  const client = useSelector((state) => state.client.client);
  const default_configs = client ? JSON.parse(client.default_configs) : {};
  const blog_page_settings = client ? JSON.parse(client.blog_page_settings) : "";
  const footer_settings = client ? JSON.parse(client.footer_settings) : null;
  const footer_copy_right_text = footer_settings ? footer_settings.footer_copy_right.norwegian : null;
  const theme_settings = client ? JSON.parse(client.theme_settings) : {};

  const logo = baseUrl.includes("localhost") ? "https://localhost/chamcore/chameleon/uploads/clients/logo/" + footer_settings?.logo_home : "https://chamcore.com/chameleon/uploads/clients/logo/" + footer_settings?.logo_home;

  const navigate = useNavigate();

  const openAllBlogs = () => {
    navigate(`/blogs`, {
      state: { scrollPosition: window.scrollY }
    });
  };


  return (
    <footer className="px-6 md:px-10 pt-12 pb-8 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        <div>
          <h3 className="text-2xl font-bold text-gray-900"><Link
            to="/"
            className="flex items-center gap-2" // 👈 makes logo & text inline
          >
            <img
              src={logo}
              alt={client.name}
              className="h-8 w-auto" // 👈 keeps consistent size
            />
            {footer_settings?.logo_home_not_sqaure ? (
              <span>{footer_settings.company_brand_name}</span>
            ) : null}
          </Link></h3>
          {/* <p className="mt-4 text-gray-600">{T.footer.getApp}</p> */}
          {/* <div className="flex gap-3 mt-4">
            <a className="bg-black text-white rounded-xl px-4 py-2 text-xs font-medium" href="#">
              App Store
            </a>
            <a className="bg-black text-white rounded-xl px-4 py-2 text-xs font-medium" href="#">
              Google Play
            </a>
          </div> */}
          <div className="flex items-center gap-4 mt-6 text-gray-500">
            {footer_settings?.footer_twitter && (
              <a
                href={footer_settings.footer_twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-purple-600 transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
            )}

            {footer_settings?.footer_face_book && (
              <a
                href={footer_settings.footer_face_book}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-purple-600 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            )}

            {footer_settings?.footer_linked_in && (
              <a
                href={footer_settings.footer_linked_in}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-purple-600 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            )}

            {footer_settings?.footer_instagram && (
              <a
                href={footer_settings.footer_instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-purple-600 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            )}
          </div>
        </div>

        <div>
          <h4 className="font-semibold text-gray-700 mb-3">{T.footer.explore}</h4>
          <ul className="space-y-2 text-gray-600">
            <li>
              <a href="/agents" className="hover:text-purple-700">
                {T.footer.advisors}
              </a>
            </li>
            {blog_page_settings.recent_blogs_section === "yes" && theme_settings?.blog_settings?.selectedBlog ? (
              <li>
                <a onClick={() => openAllBlogs()} className="hover:text-purple-700 cursor-pointer">
                  {T.footer.blog}
                </a>
              </li>
            ) : ('')}
            {default_configs.wallet_payment === "yes" && theme_settings?.wallet_settings?.selectedWallet === "walletA" && (
              <li>
                <a href="/payment-methods" className="hover:text-purple-700">
                  Payment methods
                </a>
              </li>
            )}


          </ul>
        </div>

        {/* <div>
          <h4 className="font-semibold text-gray-700 mb-3">{T.footer.special}</h4>
          <ul className="space-y-2 text-gray-600">
            {T.categories.map((c, i) => (
              <li key={i}>
                <a href="#" className="hover:text-purple-700">
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div> */}

        <div>
          <h4 className="font-semibold text-gray-700 mb-3">{T.footer.more}</h4>
          <ul className="space-y-2 text-gray-600">
            {/* <li>
              <a href="#" className="hover:text-purple-700">
                {T.footer.applyCode}
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-purple-700">
                {T.footer.support}
              </a>
            </li>
            <li>
              <Link to="/contact" className="hover:text-purple-700">
                {T.footer.about}
              </Link>
            </li> */}
            <li>
              <a href="/agents" className="hover:text-purple-700">
                {T.footer.apply}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500 gap-4">
        <p>{footer_copy_right_text}s</p>
        <div className="flex gap-6">
          <a href="/personvern" className="hover:text-purple-700">
            {T.footer.privacy}
          </a>
          <a href="/vilkar" className="hover:text-purple-700">
            {T.footer.terms}
          </a>
        </div>
      </div>
    </footer>
  );
}